<template>

  <el-container class="home-container">

    <!-- 侧边栏 -->
    <el-aside :width="isCollapse ? '64px' : '160px'">
      <!-- 头部logo -->
      <template>
        <div class="header-title" v-if="!isCollapse">
          <el-image style="width: 30px;" :src="require('../assets/images/logo透.png')"fit="cover"></el-image>
          <!-- <img width="20%" height="80%" :src="require('../assets/images/logo透.png')" style="border-radius: 5px"> -->
          <span style="font-weight:bold">越南管理系统</span>
        </div>
        <div class="header-title-hiddle" v-else>
          <el-image style="width: 30px;" :src="require('../assets/images/logo透.png')"fit="cover"></el-image>
          <!-- <img width="40px" height="40px" src="../assets/images/logo透.png" style="border-radius: 5px"> -->
        </div>
      </template>

      <!-- 菜单区域 -->
      <el-menu background-color="#282C34" text-color="#fff" active-text-color="#fff" :collapse="isCollapse"
        :collapse-transition="false" :default-active="'/' + activePath" router>
        <!-- unique-opened 只展开一个菜单 -->
        <template v-for="item in menuList">

          <!-- <el-submenu v-if="item.children" :index="item.path" :key="item.id">
            <template slot="title">
              <i :class="item.class"></i>
              <span slot="title">{{ item.label }}</span>
            </template>
  <el-menu-item v-for="(items, key) in item.children" :key="key" :index="items.path" @click="selectMenu(items)">
    <!-- <i :class="items.class"></i> -->
          <!-- <span slot="title">{{ items.label }}</span> -->
          <!-- {{ items.label }} -->
          <!-- </el-menu-item>
            
          </el-submenu>
          <el-menu-item @click="selectMenu(item)" v-else :index="item.path">
            <i :class="item.class"></i>
            <span slot="title">{{ item.label }}</span>
          </el-menu-item>  -->
          <el-submenu v-if="item.children" :index="item.path" :key="item.id">
            <template slot="title">
              <i :class="item.clazz"></i>
              <span slot="title">{{ item.label }}</span>
            </template>
            <el-menu-item v-if="!itemChild.children" v-for="itemChild in item.children" :index="itemChild.path"
              :key="itemChild.id" @click="selectMenu(itemChild)">
              <template slot="title">
                <!-- <i :class="item.class"></i> -->
                <span slot="title">{{ itemChild.label }}</span>
              </template>
            </el-menu-item>
            <template v-for="itemChild in item.children">
              <el-submenu v-if="itemChild.children" :index="itemChild.path" :key="itemChild.id">
                <template slot="title">
                  <i :class="itemChild.class"></i>
                  <span slot="title">{{ itemChild.label }}</span>
                </template>
                <el-menu-item @click="selectMenu(itemChild_child)" v-for="itemChild_child in itemChild.children"
                  :index="itemChild_child.path" :key="itemChild_child.id">
                  <template slot="title">
                    <!-- <i :class="item.class"></i> -->
                    <span slot="title">{{ itemChild_child.label }}</span>
                  </template>
                </el-menu-item>
              </el-submenu>
            </template>
          </el-submenu>
          <el-menu-item @click="selectMenu(item)" v-else :index="item.path">
            <i :class="item.class"></i>
            <span slot="title">{{ item.label }}</span>
          </el-menu-item>



        </template>

      </el-menu>
    </el-aside>

    <!-- 主体 -->
    <el-container>
      <!-- 头部 -->
      <el-header>

        <!-- 头部导航栏 -->
        <div class="header-row">
          <!-- 折叠 展开 和 名人名言 -->
          <div class="toggle-button">
            <div>
              <i :title="isCollapse ? '展开' : '收起'" class="fa fa-bars" @click="toggleCollapse"></i>
            </div>
            <!-- <div style="height:20px;width:100%;margin-left:10px">
              <div style="float:left;color:#E74405;font-size:16px;height:20px;line-height:20px;">
                <i class="fa fa-bullhorn"></i>
              </div>
              <el-carousel height="25px" direction="vertical" indicator-position="none" autoplay :interval="8000">

                <el-carousel-item v-for="item in mottoList" :key="item">
                  <h3 class="medium">{{ item }}</h3>
                </el-carousel-item>
              </el-carousel>
            </div> -->
          </div>

          <!-- 头像下拉菜单 --> 
          <div class="header-avatar">
            <div class="user">
              {{ this.information }}，您好！
            </div>
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                <img width="35" height="35" style="border-radius:50%;background:#dddddd"
                  src="../assets/images/index/user3.png" alt="">
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="update-password">修改密码</el-dropdown-item>
                <el-dropdown-item command="logout">退出登录</el-dropdown-item>
                <!-- <el-dropdown-item command="test">测试</el-dropdown-item>
                <el-dropdown-item command="request">新请求</el-dropdown-item> -->

              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>

        <!-- tab标签页区域 - 用于标签页切换 
        <div class="tabs-switch-page">
          <el-tag size="medium" v-for="(tab, index) in tabList" :key="tab.name" @close="handleClose(tab, index)"
            @click="changeMenu(tab)" :closable="tab.name !== 'home'"
            :effect="activePath === tab.name ? 'dark' : 'plain'">
            {{ tab.label }}
          </el-tag>
        </div>-->
        <div class="tabs-switch-page" @contextmenu.prevent="showContextMenu($event)">
          <el-tag size="medium" v-for="(tab, index) in tabList" :key="tab.name" @close="handleClose(tab, index)"
            @click="changeMenu(tab)" :closable="tab.name !== 'home'"
            :effect="activePath === tab.name ? 'dark' : 'plain'">
            {{ tab.label }}
          </el-tag>
        </div>
        <div v-show="showContext" :style="{ left: left + 'px', top: top + 'px' }" class="zdiv">
          <li @click="closeAllTabs">关闭所有标签</li>
          <li @click="closeOtherTab">关闭其他标签</li>
        </div>

      </el-header>

      <!-- 内容区 -->
      <el-main>
        <!-- 路由占位符，用于展示内容区的内容 -->
        <div >
          <!-- <div style="padding:1px"> -->
          <keep-alive :include="catch_components">
            <router-view />
          </keep-alive>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import req from '../utils/index'
import url1 from '../config/url1'
import request from '../utils/request'
export default {
  components: {
  },
  //组件被创建
  created() {
    //加载菜单
    this.loadMenu();
    this.inFormation();
  },
  mounted () {
    document.addEventListener('click', this.hideMenu);;
  },
  computed: {
    ...mapState({ // 从 state 中的到的计算属性
      activePath: state => state.activePath, // 已选中菜单
      tabList: state => state.tabList,  // tags菜单列表
      catch_components: state => state.catch_components,  // keepalive缓存
    })
  },
  data() {
    return {
      //菜单列表
      menuList: [],
      // 折叠-展开 默认false不折叠 
      isCollapse: false,
      // 系统公告
      mottoList: [
        '等风来不如追风去，追逐的过程就是人生的意义',
        '当你想要放弃了，那就想想当初为什么开始',
        '自强之人谁也打不倒，自弃之人谁也带不动',
        '既然无法选择回去的路程，那么就清晰的面对已经造成的挑战',
        '在难过的时候，不要忘记自己还要前进',
        '人生能有几次搏？莫到白发还未博'
      ],
      information: '',
      showContext: false,
      left: 0, // 右键菜单的位置
      top: 0, // 右键菜单的位置
      target: "",//邮寄鼠标内容
    }
  },
  methods: {
    hideMenu(){
      this.showContext = false;
    },
      // 新增或修改的方法
      showContextMenu(e) {
      // event.preventDefault();
      // event.stopPropagation();
      this.showContext = true;
      this.target = e.target.textContent.trim();
      this.left = e.clientX;
      this.top = e.clientY;
    },

    closeAllTabs() {
      var oldTabList = this.$store.state.tabList;
      // var oldActivePath = this.$store.state.activePath
      const newtabList = oldTabList.filter(tab => tab.name == 'home');
      this.showContext = false;
      oldTabList = newtabList;
      this.$store.commit('closeTab', { activePath: 'home', tabList: oldTabList });
      this.$router.push("/home")

    },
    closeOtherTab() {
      var oldTabList = this.$store.state.tabList;
      const targetObject = oldTabList.find(tab => tab.label == this.target);
      const path = targetObject.path;
      const name = targetObject.name;
      // var oldActivePath = this.$store.state.activePath
      const newTabList = oldTabList.filter(tab => (tab.name == 'home' || tab.name == name));
      this.showContext = false;
      oldTabList = newTabList;
      this.$store.commit('closeTab', { activePath: path, tabList: oldTabList });
      this.$router.push(`/${path}`)
    },
    changePWD() {
      this.$router.push("/changePWD");
    },

    // 获取登陆人姓名
    inFormation() {
      const value = localStorage.getItem('name');
      this.information = value;

    },
    // 测试鉴权
    test() {
      let URL1 = `${url1.test}`
      req.get(URL1).then(res => {
      })
    },
    newReq() {
      let URL1 = `${url1.test}`
      request.get("/sys/test").then(res => {
      })
    },
    // 退出登录请求
    logOut1() {
      let URL = `${url1.logout}`
      req.post(URL).then(res => {
        if (res.data.code === 200) {
          this.$message({
            type: 'success',
            message: res.data.data,
          });
          localStorage.removeItem('token');
          localStorage.clear();
          //跳转到首页
          this.$router.push("/login");

        } else {
          alert(res.data.message);
          localStorage.removeItem('token');
          localStorage.clear();
          // this.$router.push("/login");
        }

      })
      // .catch(error =>{
      //     alert(res.message)
      // })
    },
    // 右上角下拉菜单点击事件
    handleCommand(command) {
      switch (command) {
        // 退出
        case 'logout':
          //消息提示
          // this.msg.success('退出登录')
          //重置vuex中的数据
          // 退出登录
          this.logOut1()
          this.$store.commit('clearVUEX')

          break
        case 'test':
          this.test()
          break;
        case 'request':
          this.newReq()
          break;
        //修改密码
        case 'update-password':
          this.changePWD()
          //消息提示
          // this.msg.success('修改密码')
          break
      }
    },
    // 点击折叠 展开菜单
    toggleCollapse() {
      this.isCollapse = !this.isCollapse;
    },
    // 点击菜单 - 传入name，添加到keepalive缓存页面
    selectMenu(item) {
      // 加入keepalive缓存
      this.$store.commit('addKeepAliveCache', item.name)
      //添加tags标签
      //访问wellcome 就代表home
      var name = item.name === 'wellcome' ? 'home' : item.name
      var submenu = {
        path: name,
        name: name,
        label: item.label
      }
      //修改选中菜单
      this.$store.commit('selectMenu', submenu)
    },
    // 关闭tab标签
    handleClose(tab, index) {
      // 历史选中菜单
      var oldActivePath = this.$store.state.activePath
      // 历史已选中菜单列表
      var oldTabList = this.$store.state.tabList
      // 计算标签个数
      let length = oldTabList.length - 1
      // 删除tabList中的该对象
      for (let i = 0; i < oldTabList.length; i++) {
        let item = oldTabList[i]
        if (item.name === tab.name) {
          oldTabList.splice(i, 1);
        }
      }
      // 删除keepAlive缓存
      this.$store.commit('removeKeepAliveCache', tab.name)
      // 如果关闭的标签不是当前路由的话，就不跳转
      if (tab.name !== oldActivePath) {
        return
      }
      // 如果length为1，必然只剩下首页标签，此时关闭后，更新到首页
      if (length === 1) {
        // 同时存储菜单
        this.$store.commit('closeTab', { activePath: 'home', tabList: oldTabList })
        // tab页向左跳转
        this.$router.push({ name: oldTabList[index - 1].name })
        // 不再向下执行
        return
      }
      // 关闭的标签是最右边的话，往左边跳转一个
      if (index === length) {
        // 同时更新路径
        oldActivePath = oldTabList[index - 1].name
        // 同时存储菜单
        this.$store.commit('closeTab', { activePath: oldActivePath, tabList: oldTabList })
        // tab页向左跳转
        this.$router.push({ name: oldTabList[index - 1].name })
      } else {
        // 同时更新路径
        oldActivePath = oldTabList[index].name
        // 同时存储菜单
        this.$store.commit('closeTab', { activePath: oldActivePath, tabList: oldTabList })
        // tab页向右跳转
        this.$router.push({ name: oldTabList[index].name })
      }
    },
    // 点击标签跳转路由
    changeMenu(item) {
      // 历史选中菜单
      var oldActivePath = this.$store.state.activePath
      // 首先判断点击的是否是自己，如果是自己则return
      if (oldActivePath === item.name) {
        return
      }
      // 不是自己，存储菜单
      this.$store.commit('changeMenu', item.name)
      // 页面跳转
      this.$router.push({ name: item.name })
    },
    //加载菜单
    loadMenu() {
      let URL = `${url1.getModules}`;
      req.get(URL).then(res => {
        if (res.data.code === 200) {
          this.menuList = res.data.data;
        }else{
          this.$message({
            type: 'error',
            message: res.data.message,
          });
        }
      })
      // this.menuList = [
      //   {
      //     id: 'number-01',
      //     class: 'fa el-icon-document',
      //     path: '/home',
      //     label: '首页',
      //     name: 'home'
      //   },
      //   {
      //     id: 'number-02',
      //     class: 'fa icon iconfont icon-chakan',
      //     path: '/viewMaterial',
      //     label: '基础资料',
      //     name: 'viewMaterial',
      //     children: [
      //       {
      //         id: 'number-03',
      //         class: 'fa icon iconfont icon-chakan',
      //         path: '/costInformation',
      //         label: '费用信息',
      //         name: 'costInformation'
      //       },
      //       {
      //         id: 'number-04',
      //         class: 'fa icon iconfont icon-chakan',
      //         path: '/stuffInformation',
      //         label: '人员信息',
      //         name: 'stuffInformation'
      //       },
      //       {
      //         id: 'number-06',
      //         class: 'fa icon iconfont icon-chakan',
      //         path: '/correspondent',
      //         label: '往来单位',
      //         name: 'correspondent'
      //       },
      //       {
      //         id: 'number-15',
      //         class: 'fa icon iconfont icon-chakan',
      //         path: '/expenseTemplates',
      //         label: '费用方案',
      //         name: 'expenseTemplates'
      //       },
      //       {
      //         id: 'number-07',
      //         class: 'fa icon iconfont icon-danwei',
      //         path: '/correspondent',
      //         label: '字典管理',
      //         name: 'correspondent',
      //         children: [
      //           {
      //             id: 'number-08',
      //             class: 'fa icon iconfont icon-chakan',
      //             path: '/dictionaryType',
      //             label: '字典类型',
      //             name: 'dictionaryType'
      //           },
      //           {
      //             id: 'number-09',
      //             class: 'fa icon iconfont icon-chakan',
      //             path: '/dictionaryData',
      //             label: '字典资料',
      //             name: 'dictionaryData'
      //           },
      //         ]
      //       },
      //     ]
      //   },
      //   {
      //     id: 'number-010',
      //     class: 'fa icon iconfont icon-renwuxiafa',
      //     path: '/operationControl',
      //     label: '业务管理',
      //     name: 'operationControl',
      //     children: [
      //       {
      //         id: 'number-011',
      //         class: 'fa icon iconfont icon-chakan',
      //         path: '/orderManagement',
      //         label: '订单管理',
      //         name: 'orderManagement'
      //       },
      //     ]
      //   },
      //   {
      //     id: 'number-012',
      //     class: 'fa icon iconfont icon-iconfontscan',
      //     path: '/financialManagement',
      //     label: '财务管理',
      //     name: 'financialManagement',
      //     children: [
      //       {
      //         id: 'number-013',
      //         class: 'fa icon iconfont icon-chakan',
      //         path: '/useFund',
      //         label: '资金使用申请',
      //         name: 'useFund'
      //       },
      //       {
      //         id: 'number-014',
      //         class: 'fa icon iconfont icon-chakan',
      //         path: '/invoiceRequest',
      //         label: '发票申请',
      //         name: 'invoiceRequest'
      //       },
      //       {
      //         id: 'number-015',
      //         class: 'fa icon iconfont icon-chakan',
      //         path: '/collectionLedger',
      //         label: '收款台账',
      //         name: 'collectionLedger'
      //       },
      //     ]
      //   },
      //   {
      //     id: 'number-016',
      //     class: 'fa icon iconfont icon-chakan',
      //     path: '/gridReport',
      //     label: '报表中心',
      //     name: 'gridReport',
      //     children: [
      //       {
      //         id: 'number-017',
      //         class: 'fa icon iconfont icon-chakan',
      //         path: '/customerReport',
      //         label: '客户账单',
      //         name: 'customerReport'
      //       },
      //      ]
      //   },

      // ]
    }
  },
};
</script>
<style lang="less" scoped>
.zdiv {
  margin: 0;
  border: 1px solid rgb(187, 186, 186);
  background: rgb(255, 255, 255);
  z-index: 1000;
  position: absolute;
  list-style-type: none;
  padding: 5px;
  border-radius: 7px;
  font-size: 12px;
}

.zdiv li {
  margin: 0;
  padding: 5px;
  padding-top: 7px;
  padding-bottom: 7px;
}

.zdiv li:hover {
  background: #e1e1e1;
  cursor: pointer;
}
.el-col-align-middle {
  line-height: 40px;
  text-align: left;
  font-size: 14px;
}

.home-container {
  height: 100%;
}

.el-header {
  color: rgb(0, 0, 0);
  font-size: 20px;
  border-bottom: 1px solid #dddddd;
  height: 82px !important;
  padding: 0;
  background: #fff;
}

.header-row {
  height: 40px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  border-bottom: 1px solid #dddddd;
  overflow: hidden;
}

.header-avatar {
  float: right;
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 20px;

  .user {
    font-size: 14px;
    font-weight: bold;
    padding: 0 10px;
  }
}

.el-aside {
  background-color: #282C34;

  .header-title {
    padding-left: 5px;
    height: 60px;
    font-weight: 300;
    display: flex;
    font-size: 18px;
    align-items: center;
    cursor: pointer;
    color: #ffffff;

    span {
      margin-left: 10px;
    }
  }

  .header-title-hiddle {
    width: 64px;
    height: 60px;
    display: table-cell;
    vertical-align: middle;
    text-align: center;
    color: #ffffff;
    cursor: pointer;
  }

  .el-menu {
    border-right: none;
  }
}

// 菜单选中背景色
.el-menu-item.is-active {
  background-color: #1890FF !important;
}

// 菜单悬浮背景色
.el-menu-item:hover {
  background-color: #1890FF !important;
}

// 走马灯
.el-carousel__item h3 {
  color: #ee7c12;
  font-size: 14px;
  opacity: 0.75;
  line-height: 25px;
  margin: 0;
}

.el-main {
  background-color: #eaedf1;
  padding: 0;
}

.fa {
  margin-right: 10px;
}

// 点击展开/折叠按钮
.toggle-button {
  width: 80%;
  font-size: 20px;
  line-height: 40px;
  color: #595959;
  text-align: left;
  display: flex;
  align-items: center;
  float: left;
  padding-left: 20px;

  i {
    cursor: pointer;
  }
}

// 面包屑导航
.el-breadcrumb {
  margin-bottom: 0;
}

// tab页
.tabs-switch-page {
  display: flex;
  align-items: center;
  height: 40px;
  background-color: #fff;
  overflow: hidden;
}

.el-tag {
  cursor: pointer;
  margin-left: 10px;
  border-radius: 2px;
  font-size: 12px;
  color: #1890FF;
  border-color: #1890FF;
}

.el-tag--dark {
  color: #fff;
  background-color: #1890FF;
}

.el-dropdown-link {
  cursor: pointer;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.submit-row {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}
</style>